<template>
    <div>
        <Header :title="title" :showBack="true"></Header>

        <div class="LineClassPicker">
            <div>
                <van-cell-group title="线路信息">
                    <van-cell icon="logistics" title="路线" :value="line.text" />
                    <van-cell icon="location-o" title="站点" :value="node.NodeName" />
                    <van-cell icon="clock-o" title="日期" :value="selectDate" />
                </van-cell-group>
            </div>
            <div>
                <van-cell-group title="车辆信息">
                    <van-search v-model="VehicleNo" placeholder="请输入搜索车牌号" show-action shape="round"
                        @search="onSearchNo">
                        <div slot="action" @click="onSearchNo">搜索</div>
                    </van-search>
                    <van-cell title="车牌号码" title-class="Title-CellClass" value-class="Value-CellClass"
                        :value="selectVehicle.VehicleNo">
                    </van-cell>
                    <van-cell style="display: flex; justify-content: space-between" title="运输企业"
                        title-class="Title-CellClass">
                        <template slot="right-icon">
                            <van-tag v-if="selectVehicle.BusinessUnit" style type="success" class="tagQuInfo">{{
            selectVehicle.BusinessUnit.substring(0,
                12) }}</van-tag>
                        </template>
                    </van-cell>
                </van-cell-group>

                <van-cell-group class="driver-info" title="司机信息">
                    <van-search v-model="DriverNameOrTel" placeholder="请输入姓名或手机号搜索司机" show-action shape="round"
                        @search="onSearchDriver">
                        <div slot="action" @click="onSearchDriver">搜索</div>
                    </van-search>
                    <van-cell title="姓名" title-class="Title-CellClass" value-class="Value-CellClass"
                        :value="selectDriver.Driver1Name"></van-cell>
                    <van-cell title="手机号" title-class="Title-CellClass" value-class="Value-CellClass"
                        :value="selectDriver.Driver1Tel"></van-cell>
                    <van-cell title="从业资格证" title-class="Title-CellClass" value-class="Value-CellClass"
                        :value="selectDriver.Driver1IndustryCertNo"></van-cell>
                </van-cell-group>

            </div>

            <div>
                <van-cell-group title="发车信息">
                    <!-- 允许输入数字，调起带符号的纯数字键盘 -->
                    <van-field v-model="psgNum" type="number" label="发车人数" />
                </van-cell-group>
            </div>

            <van-button style="margin-top: 0.5rem;" type="warning" @click="doSendCar" block>发车</van-button>
        </div>



        <!-- 车辆选择 -->
        <van-popup v-model="showVehicleNoPicker" position="bottom">
            <van-picker show-toolbar :columns="VehicleNoList" @cancel="onCancelVehicleNoPicker"
                @confirm="onConfirmVehicleNoPicker" :loading="showVehicleNoPickerLoading" />
        </van-popup>
        <!-- 司机选择 -->
        <van-popup v-model="showDriverPicker" position="bottom">
            <van-picker show-toolbar :columns="DriverList" @cancel="onCancelDriverPicker"
                @confirm="onConfirmDriverPicker" :loading="showDriverLoading" />
        </van-popup>
    </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import dateCalendarStore from "@/stores/dateCalendarStore";

export default {
    components: {
        Header
    },
    data() {
        return {
            title: "线路发车", //页面标题
            selectDate: this.$moment(this.$route.params.selectDate).format('YYYY-MM-DD'),
            line: JSON.parse(window.localStorage.getItem("line")), //选择的线路
            node: window.localStorage.getItem("LineCheckTicket_SelectStartNode")
                ? JSON.parse(window.localStorage.getItem("LineCheckTicket_SelectStartNode"))
                : null, //选择的站点
            showVehicleNoPicker: false,
            showVehicleNoPickerLoading: false,
            VehicleNoList: [],
            VehicleNo: null,
            DriverNameOrTel: null,
            psgNum: null,
            selectVehicle: {
                VehicleNo: "",
                BusinessUnit: ""
            },
            showDriverPicker: false,
            showDriverLoading: false,
            selectDriver: {
                Driver1Name: "",
                Driver1Tel: "",
                Driver1IndustryCertNo: ""
            },
            DriverList: []
        };
    },
    watch: {},
    methods: {
        //取消司机选择
        onCancelDriverPicker() {
            this.DriverList = [];
            this.DriverNameOrTel = "";
            this.showDriverPicker = false;
        },
        //选中司机
        onConfirmDriverPicker(value) {
            if (value) {
                this.DriverList = [];
                this.DriverNameOrTel = "";
                this.showDriverPicker = false;
                this.selectDriver.Driver1GID =
                    value.keyID;
                this.selectDriver.Driver1Name =
                    value.text;
                this.selectDriver.Driver1Tel =
                    value.tel;
                this.selectDriver.Driver1IndustryCertNo = value.industryCertNo;
            }
        },
        //司机搜索
        onSearchDriver() {
            this.showDriverPicker = true;
            this.showDriverLoading = true;
            this.DriverList = []
            let params = {
                CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
                DriverNameOrTel: this.DriverNameOrTel,
            };
            this.$http
                .post(this.$api.onCompDriverQuery, this.$qs.stringify(params))
                .then((res) => {
                    if (res.success) {
                        for (let i = 0; i < res.data.length; i++) {
                            this.DriverList.push({
                                text: res.data[i].DriverName,
                                keyID: res.data[i].DriverGID,
                                industryCertNo: res.data[i].IndustryCertNo,
                                IsVerified: res.data[i].IsVerified,
                                driverCertNo: res.data[i].DriverCertNo,
                                tel: res.data[i].DriverTel,
                            });
                        }
                    }
                    this.DriverNameOrTel = "";
                    this.showDriverLoading = false;
                });
        },
        //发车
        doSendCar() {
            if (!this.selectVehicle.VehicleNo) {
                this.$toast("请选择车辆");
                return;
            }
            if (!this.psgNum) {
                this.$toast("请输入发车人数");
                return;
            }
            let params = {
                _JsonText: JSON.stringify({
                    LineGID: this.line.lineInfo.LineGID,
                    ClassDate: this.selectDate,
                    NodeGID: this.node.NodeGID,
                    VehicleGID: this.selectVehicle.VehicleGID,
                    DriverGID: this.selectDriver.Driver1GID,
                    PassengerCount: this.psgNum,
                    ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
                    ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                        .UserCode,
                    ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
                        .UserName,
                }),
            };
            this.$http
                .post(this.$api.LineDepartureRecordCreate, this.$qs.stringify(params))
                .then((res) => {
                    if (res.success) {
                        this.$toast("发车成功");
                        var that = this;
                        setTimeout(function () {
                            that.$router.go(-1);
                        }, 1000);

                    } else {
                        this.$dialog
                            .alert({
                                title: "提示",
                                message: res.msg,
                            })
                            .then(() => {

                            });
                    }
                });
        },
        //选中车牌
        onConfirmVehicleNoPicker(value) {
            this.VehicleNoList = [];
            this.showVehicleNoPicker = false;
            this.selectVehicle.VehicleNo = value.vno;
            this.selectVehicle.VehicleGID = value.keyID;
            this.selectVehicle.CodeName = value.color;
            this.selectVehicle.YeHuDaiMa =
                value.data.YeHuDaiMa;
            this.selectVehicle.BusinessUnit =
                value.data.BusinessUnit;
            this.selectVehicle.VehicleGPSCode =
                value.VehicleGPSCode;
            this.VehicleNo = "";
        },
        //车牌搜索内容退出
        onCancelVehicleNoPicker() {
            this.VehicleNoList = [];
            this.VehicleNo = "";
            this.showVehicleNoPicker = false;
        },
        //车牌号搜索
        onSearchNo() {
            this.VehicleNoList = [];
            this.showVehicleNoPicker = true;
            this.showVehicleNoPickerLoading = true;
            let params = {
                CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
                VehicleNo: this.VehicleNo,
                sort: "VehicleNo",
            };
            this.$http
                .post(this.$api.onCompVehicleQuery, this.$qs.stringify(params))
                .then((res) => {
                    if (res.success) {
                        for (let i = 0; i < res.data.length; i++) {
                            this.VehicleNoList.push({
                                text:
                                    res.data[i].VehicleNo +
                                    "-(" +
                                    res.data[i].PassengerSeatCount +
                                    ")",
                                keyID: res.data[i].VehicleGID,
                                color: res.data[i].CodeName,
                                vno: res.data[i].VehicleNo,
                                VehicleGPSCode: res.data[i].VehicleGPSCode,
                                data: res.data[i],
                            });
                        }
                    }
                    this.showVehicleNoPickerLoading = false;
                });
        },
    },
    mounted: function () {

    },
    created() { }
};
</script>

<style scoped lang="less">
.LineClassPicker {
    width: 95%;
    margin: 10px auto;
    text-align: -webkit-auto;
}

.van-cell__value {
    color: black;
}

.van-cell {
    font-size: 14px;
}

.van-cell__label {
    font-size: 12px;
    color: #323233;
}

.cancelSendCarShow {
    width: 80%;
    height: auto;
    text-align: center;
    font-size: 0.4rem;
    border-radius: 0.2rem;

    .title {
        width: 100%;
        height: 0.86rem;
        line-height: 0.86rem;
        background-color: #eee;
    }

    .content {
        padding: 0.4rem 0;
    }

    .btn {
        width: 100%;
        height: 0.86rem;
        line-height: 0.86rem;
        display: flex;
        justify-content: space-around;
        padding-bottom: 0.4rem;

        button {
            padding: 0 0.4rem;
            color: #fff;
            border-radius: 0.2rem;
        }

        button:first-child {
            background: #2891e7;
        }

        button:last-child {
            background: #ffb870;
        }
    }
}
</style>